import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IHknrAccount } from '../types/hknr-account.type';

interface HknrAccountInitialState extends BaseDataReducerInitialState<any> {
  account: IHknrAccount | null;
}

const { initialState, AC, reducer } = basedDataReducer<any, HknrAccountInitialState>('hknr-account');

const hknrInitialState: HknrAccountInitialState = {
  ...initialState,
  account: null,
};

export const hknrAccount = createSlice({
  name: 'hknrAccount',
  initialState: hknrInitialState,
  reducers: {
    setHknrAccount: (state, action: PayloadAction<IHknrAccount | null>) => {
      state.account = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as HknrAccountInitialState, action);
    });
  },
});
export const HknrAccountAC = AC;

export const { setHknrAccount } = hknrAccount.actions;
